/** ⌥ im `ShortcutBadge` — gezeichnet wie die Pfeiltasten (`KeyArrowIcons`), nicht getippt. */
export const OptionKeyIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 2.5H3.5L8.5 9.5H11.5M7.5 2.5H11.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
